"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationService = void 0;
const service_1 = require("./service");
class NotificationService extends service_1.Service {
    constructor(transport, auth) {
        super(transport, auth);
    }
    async getMentions() {
        const response = await this.transport.send('mm');
        if (response.status === 0 && Array.isArray(response.data) && Array.isArray(response.data[0])) {
            return response.data[0].map((item) => ({
                forumId: item[2],
                forumTitle: item[3],
                topicId: item[4],
                topicTitle: item[5],
                postId: item[6],
                authorId: item[8],
                authorName: item[9],
                timestamp: item[11],
                avatarUrl: item[15]
            }));
        }
        return [];
    }
}
exports.NotificationService = NotificationService;
